import { useEffect } from 'react'
import moment from 'moment-timezone'

/**
 * Sets moment's default timezone for the component lifecycle and resets it on unmount.
 * Generally used for displaying times in a location/carpark-specific timezone.
 *
 * @param {string} [timeZone] - IANA timezone (e.g. 'Europe/London'). If falsy, no change is made.
 */
export default function useLocationTimezone(timeZone) {
    useEffect(() => {
        if (timeZone) {
            moment.tz.setDefault(timeZone)
        }

        return () => {
            moment.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone)
        }
    }, [timeZone])
}
